// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type PortfolioBacktest } from '@shared/data-access/interfaces/api/ai/portfolio';
import { PerformanceLineChart } from '@shared/ui-kit/features/performance-line-chart';
import { KpiBoxes } from '@shared/ui-kit/components';
import { type FC } from 'react';
import { type PortfolioAnalysis } from '@shared/data-access/interfaces/api/ai/portfolio-analysis';
import { useBacktest } from '../hooks';
import { useTranslation } from 'react-i18next';

export interface BacktestProps {
  analysis: PortfolioAnalysis;
  backtest: PortfolioBacktest | null;
  loading: boolean;
}

export const Backtest: FC<BacktestProps> = ({ analysis, backtest, loading }) => {
  const { t } = useTranslation();
  const { kpiData } = useBacktest({ analysis, backtest, loading });

  return (
    <div>
      <div className="grid grid-cols-4 gap-6">
        {kpiData.map((vals, idx) => (
          <KpiBoxes key={idx} {...vals} />
        ))}
      </div>

      {backtest && (
        <>
          <div className="mt-6">
            <PerformanceLineChart
              data={backtest!.ts_backtest}
              isReturns={true}
              name={t('backtest.returns', { ns: 'components' })}
            />
          </div>
          <div className="mt-6">
            <PerformanceLineChart
              data={backtest!.ts_drawdowns}
              isReturns={false}
              name={t('backtest.drawdowns', { ns: 'components' })}
              crossType="top"
            />
          </div>
        </>
      )}
    </div>
  );
};
